const volotea = {
  volotea_template: "Plantilla Volotea",
  supplierEmail: "Correo electronico del proveedor",
  email: "Correo Electrónico",
  createTitle: "Crear Proveedor",
  editTitle: "Editar Proveedor",
  supplierId: "ID del Proveedor",
  registrationNumber: "Número de Registro",
  triggeredBy: "El onboarding sera completado por",
  vendorCompanyName: "Nombre del proveedor",
  customerCompanyName: "Facturar a",
  paymentTerms: "Método y condiciones de pago",
  buyerName: "Nombre y apellidos del solicitante",
  buyerManagerName: "Nombre y apellidos del manager del solicitante",
  serviceCountry: "Servicios prestados en",
  vendorType: "Tipo proveedor",
  serviceDescription: "Descripción del servicio",
  amosCode: "Código AMOS",
  officialDocument: "Documento oficial",
  companyType: "Tipo de entidad",
  taxType: "Tipo de gravamen",
  legalName: "Razón social / Nombre y Apellidos",
  taxAddress: "Domicilio fiscal",
  taxNumber: "Número de identificación fiscal",
  city: "Ciudad",
  county: "Provincia",
  postcode: "Codigo postal",
  country: "País",
  accountingContactName: "Persona contacto contabilidad",
  accountingContactEmail: "Correo electrónico contabilidad",
  accountingContactPhone: "Número de teléfono contabilidad",
  supplierType: "Proveedor de bienes o servicios",
  verificationStatus: "Estado de la verificación",
  documentValidityStatus: "Documento de validez del certificado",
  taxResidenceCertificate: "Certificado residencia fiscal",
  vendorCompanyId: "ID de empresa proveedora",
  bankName: "Nombre del banco",
  iban: "IBAN",
  swiftCode: "SWIFT/BIC",
  bankAccountCurrency: "Moneda de la cuenta bancaria",
  additionalCertificates: "Certificados adicionales",
  bankCertificate: "Certificado bancario",
  alternateBankDetails: "Datos bancarios alternativos",
  helperTexts: {
    officialDocument: "Subir documento PDF para justificar el onboarding",
    additionalCertificates: "Subir certificados adicionales en formato PDF",
    taxResidenceCertificate:
      "Subir certificado de residencia fiscal en formato PDF",
    bankCertificate: "Subir certificado bancario en formato PDF",
  },
  common: {
    cancel: "Cancelar",
    save: "Guardar",
    update: "Actualizar",
  },
  validation: {
    email: {
      invalid: "Por favor, introduce una dirección de correo válida",
      required: "El correo electrónico es obligatorio",
    },
    registrationNumber: {
      required: "El número de registro es obligatorio",
    },
    vendorCompanyId: {
      required: "El ID de la empresa proveedora es obligatorio",
    },
    vendorCompanyName: {
      required: "El nombre del proveedor es obligatorio",
    },
    buyerName: {
      required: "El nombre del solicitante es obligatorio",
    },
    buyerManagerName: {
      required: "El nombre del manager del solicitante es obligatorio",
    },
    customerCompanyName: {
      required: "Facturar a es obligatorio",
    },
    serviceDescription: {
      required: "La descripción del servicio es obligatoria",
    },
    vendorCompanyAddress: {
      required: "La dirección del proveedor es obligatoria",
    },
    contactName: {
      required: "El nombre de contacto es obligatorio",
    },
    contactEmail: {
      required: "El correo de contacto es obligatorio",
    },
    contactPhone: {
      required: "El teléfono de contacto es obligatorio",
    },
    bankName: {
      required: "El nombre del banco es obligatorio",
    },
    iban: {
      required: "El IBAN es obligatorio",
    },
    swiftCode: {
      required: "El código SWIFT es obligatorio",
    },
    triggeredBy: {
      required: "El registro lo realiza es obligatorio",
    },
    paymentTerms: {
      required: "Las condiciones de pago son obligatorias",
    },
    vendorType: {
      required: "El tipo de proveedor es obligatorio",
    },
    country: {
      required: "El país es obligatorio",
    },
    vendorCompanyCountry: {
      required: "El país del proveedor es obligatorio",
    },
    bankAccountCurrency: {
      required: "La moneda de la cuenta bancaria es obligatoria",
    },
    supplierType: {
      required: "El tipo de proveedor es obligatorio",
    },
    companyType: {
      required: "El tipo de entidad es obligatorio",
    },
    taxType: {
      required: "El tipo de gravamen es obligatorio",
    },
    validationStatus: {
      required: "El estado de validación es obligatorio",
    },
    officialDocument: {
      required: "El documento oficial es obligatorio",
    },
    bankCertificate: {
      required: "El certificado bancario es obligatorio",
    },
    certificadosAdicionales: {
      required: "Los certificados adicionales son obligatorios",
    },
    certificadoResidenciaFiscal: {
      required: "El certificado de residencia fiscal es obligatorio",
    },
    documentValidationStatus: {
      required: "El estado de validez del documento es obligatorio",
    },
    certificadoBancario: {
      required: "El certificado bancario es obligatorio",
    },
    amosCode: {
      required: "El código AMOS es obligatorio",
    },
  },
};

export default volotea;
